

import React, { useState, useEffect } from 'react';
import { Cookies } from '../index.js';
import { Outlet, useNavigate } from "react-router-dom";
import { MdTextFields } from 'react-icons/md';
import { FaMicrophone, FaVideo, FaCloudUploadAlt, FaFileAlt } from 'react-icons/fa';
import axios from 'axios';
import { RingLoader } from "react-spinners";
function Homehust() {
    const navigate = useNavigate();

    const [sdttruyenthanh, setsdttruyenthanh] = useState(false);
    const [apikey, setapikey] = useState('');
    const [huyen, sethuyen] = useState(false);
    function switch_router(link) {
        navigate(link);
    };
    useEffect(() => {
    }, []);
    return (
        <>
            <div className="container-fluid ">
                <div className="row mt-3">
                    <div className="col-xl-4 mt-0">

                        <div className="card mb-3 bg-pink-500 shadow-lg rounded-xl">
                            <div className="grid gap-2">
                                <div className="bg-white border-2 rounded-lg shadow-md ">
                                    <div onClick={() => switch_router("/reactapp/recordaudio/" + sdttruyenthanh)} className="card">
                                        <button className="h-12 w-full flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white hover:from-pink-600 hover:to-purple-600 hover:text-white text-xl font-semibold shadow-lg focus:outline-none" type="button">
                                            <span className="ml-4">Đăng ký bằng tên tài khoản mật khẩu</span>
                                            <FaMicrophone classNameName="text-xl" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4 mt-0">
                        <div className="card mb-3 bg-pink-500 shadow-lg rounded-xl">
                            <div className="grid gap-2">
                                <div className="bg-white border-2 rounded-lg shadow-md ">
                                    <div onClick={() => switch_router("/reactapp/texttovoice/" + sdttruyenthanh)} className="card">
                                        <button className="h-12 w-full flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white hover:from-pink-600 hover:to-purple-600 hover:text-white text-xl font-semibold shadow-lg focus:outline-none" type="button">
                                            <span className="mr-2">Đăng ký nhanh bằng 1 lần ấn</span>
                                            <MdTextFields classNameName="text-xl" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-4 mt-0">
                        <div className="card mb-3 bg-pink-500 shadow-lg rounded-xl">
                            <div className="grid gap-2">
                                <div className="bg-white border-2 rounded-lg shadow-md ">
                                    <div onClick={() => switch_router("/reactapp/them20giay/" + sdttruyenthanh)} className="card">
                                        <button className="h-12 w-full flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white hover:from-pink-600 hover:to-purple-600 hover:text-white text-xl font-semibold shadow-lg focus:outline-none" type="button">
                                            <span className="mr-2">Đăng ký bằng Google account</span>
                                            <FaCloudUploadAlt classNameName="text-xl" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default Homehust
